import React from 'react'
import styles from './TileColumn.module.css'

type TileColumnProps = {
    children: React.ReactNode;
    compact?: boolean;
}

const TileColumn = ({ children, compact }: TileColumnProps) => {
  return (
    <div className={styles.container} style={compact ? { flex: 'unset' } : {}}>
        {children}
    </div>
  )
}

export default TileColumn